import ButtonField from "@/components/collections/form/ButtonComponent"
import apiClient from "@/utils/cb-client"
import Transformer from "@/utils/transformer"
import TokenizationHandler from "@/utils/tokenization-handler"
import ClientSideEncryptionHandler from "@/utils/cse-handler"
import CardCopyAddress from "@/utils/card-copy-address"
import CheckoutSubscribeComponent from "@/components/modules/hosted-pages/CheckoutSubscribeButton"
import { EventBus } from '@/utils/event-bus'
import Vue from "vue"
import CBNotification from "@/models/cb-notification"
import PaymentHelper from "@/utils/payment-helper"
import DlocalHelper from "@/utils/dlocal-helper"
import { threedsNeeded, intentFlowEnabled } from "@/components/modules/hosted-pages/LazyLoadPaymentComponents"
import { threeDSHandler, threeDSHandlerWithMandate, createPaymentIntent } from '@/models/three-ds-handler';
import { paymentMethods, paymentStep } from '@/utils/payment-helper'
import FieldConfig from "@/components/modules/hosted-pages/payment-methods/direct-debit/field-config";
import CbjsTransformer from "../utils/cbjs-transformer";
import { UpperCaseGateway } from '@/models/gateway-type';
import PaynowSubmitter from '@/utils/paynow-submitter';
import VoucherMixin from '@/mixins/payment-methods/voucher-mixin';

const { IDEAL, SOFORT, BANCONTACT, GIROPAY, DOTPAY, NETBANKING_EMANDATES, UPI, DIRECT_DEBIT, KLARNA_PAY_NOW, ONLINE_BANKING_POLAND } = paymentMethods
const { FIRST_STEP, SECOND_STEP } = paymentStep;

import {
  mapGetters, Store
} from "vuex"
export default {
  mixins: [VoucherMixin],
  created() {
    PaymentHelper.setConfig(this.$store.state, this.$store.getters)
  },
	methods: {

    isMandateEnabledPaymentMethod() {
      return PaymentHelper.isMandateEnabledPaymentMethod(this.pm)
    },

    // You can't use stored payment source without mandate
    isStrictMandatePaymentMethod() {
      return PaymentHelper.isStrictMandatePaymentMethod(this.pm)
    },

    isMultiStepPaymentMethod() {
      return PaymentHelper.isMultiStepPaymentMethod(this.payment_method_type)
    },

    isInAppBankAccountPaymentMethod() {
      return PaymentHelper.isInAppBankAccountPaymentMethod(this.pm, this.payment_method_type)
    },

    isInAppInstantBankAccountPaymentMethod(pmType) {
      pmType = pmType || this.payment_method_type
      return PaymentHelper.isInAppInstantBankAccountPaymentMethod(pmType)
    },

    isCJSButtonPaymentMethod() {
      return PaymentHelper.isCJSButtonPaymentMethod(this.payment_method_type)
    },

    isOfflinePaymentMethod() {
      return PaymentHelper.isOfflinePaymentMethod(this.payment_method_type)
    },

    isDirectDebitPaymentIntentSupported(paymentInfo) {
      return PaymentHelper.isDirectDebitPaymentIntentSupported(paymentInfo)
    },

    isInstantBankPaymentIntentSupported(paymentInfo) {
      return PaymentHelper.isInstantBankPaymentIntentSupported(paymentInfo)
    },

    canShowPaymentMethodPicker() {
      return PaymentHelper.canShowPaymentMethodPicker();
    },

    pmDisplayName() {
      return PaymentHelper.getPaymentMethodDisplayName(this.pm);
    },

    isPaymentIntentFlow(id, type, data) {
      return threedsNeeded(id, type, data) || intentFlowEnabled(id, type);
    },

    _throwError() {
      if(this.isInAppBankAccountPaymentMethod()) {
        EventBus.$emit('_displayErrorMessage');
      } else {
        this._displayErrorMessage();
      }
    },

    showTopLevelPaymentButton() {
      if(this.isMultiStepPaymentMethod() || this.isCJSButtonPaymentMethod()) {
        return (this.pm_authorized);
      }
      else {
        return true;
      }
    },

    disablePaymentSubmit() {
      return !this.pm_consent;
    },

    showPmDisplayNameAtTop() {
      return this.canShowPaymentMethodPicker() &&
      (this.one_screen_checkout ? !this.isOfflinePaymentMethod() || this.pm.payment_instruction : true);
    },

    submitDLocalFormData() {
      if(this.pm && this.pm.enabled_dlocal) {
        DlocalHelper.saveFormData(this.pm, this.$store);
      }
    },

    componentType() {
      switch (this.payment_method_type) {
        case "card":
          return "card-section";
        case "paypal_express_checkout":
          return "paypal-section";
        case "venmo":
          return "venmo-section";
        case "direct_debit":
        case 'sepa_instant_transfer':
        case 'faster_payments':
        case 'pay_to':
          return "direct-debit-section";
        case "amazon_payments":
          return "amazon-payment-section";
        case "apple_pay":
          return "apple-pay-section";
        case 'ideal':
          return 'ideal-section';
        case 'sofort':
          return 'sofort-section';
        case 'bancontact':
          return 'bancontact-section';
        case 'google_pay':
          return 'google-pay-section';
        case 'giropay':
          return 'giropay-section';
        case 'dotpay':
          return 'dotpay-section';
        case 'netbanking_emandates':
          return 'netbanking-section';
        case 'upi':
          return 'upi-section';
        case 'boleto':
          return 'boleto-section';
        case 'klarna_pay_now':
          return 'klarna-pay-now-section';
        case 'online_banking_poland':
          return 'online-banking-poland-section'
      }
      if(this.isOfflinePaymentMethod() && this.$store.getters.hosted_page_type == "checkout") {
        return 'offline-payment-section';
      }
    },

    _sendRequest(data) {
      var replacePrimary = this.$route.name == "portal_edit_payment_method";
      const _pm = this.pm;
      return Promise.resolve().then(() => {
        // TODO: we can move it to common place. Note: Testing scope will increase so i'm not handled it now.
        if (this.pm.type === 'ideal') {
          //For iDeal, we use both postActionJson and data in submitIDealCheckout method.
          return this.submitIDealCheckout({data}).then(intent => {
            return PaymentHelper.doApiRequest(
              { data,  pm: this.pm,  pmType: this.payment_method_type,  replacePrimary, intent }
            )
          })
        }
        else if (this.pm.type === 'sofort') {
          return this.submitSofortCheckout(data).then(intent => {
            return PaymentHelper.doApiRequest(
              { data,  pm: this.pm,  pmType: this.payment_method_type,  replacePrimary, intent }
            )
          })
        }
        else if (this.pm.type === 'klarna_pay_now') {
          return this.submitKlarnaPayNowCheckout(data).then(intent => {
            return PaymentHelper.doApiRequest(
              { data,  pm: this.pm,  pmType: this.payment_method_type,  replacePrimary, intent }
            )
          })
        }
        else if (this.pm.type === 'bancontact') {
          return this.submitBancontactCheckout(data).then(intent => {
            return PaymentHelper.doApiRequest(
              { data,  pm: this.pm,  pmType: this.payment_method_type,  replacePrimary, intent }
            )
          })
        }
        else if (this.pm.type === 'giropay') {
          return this.submitGiropayCheckout().then(intent => {
            return PaymentHelper.doApiRequest(
              { data,  pm: this.pm,  pmType: this.payment_method_type,  replacePrimary, intent }
            )
          })
        }
        else if (this.pm.type === 'netbanking_emandates') {
          return this.submitNetbankingEmandate(data).then(intent => {
            return PaymentHelper.doApiRequest(
              { data,  pm: this.pm,  pmType: this.payment_method_type,  replacePrimary, intent }
            )
          })
        }
        else if (this.pm.type === 'online_banking_poland') {
          return this.submitOnlineBankingPoland(data).then(intent => {
            return PaymentHelper.doApiRequest(
              { data,  pm: this.pm,  pmType: this.payment_method_type,  replacePrimary, intent }
            )
          })
        }
        else if (this.pm.type === 'upi') {
          return this.submitUpiCheckout(data).then(intent => {
            return PaymentHelper.doApiRequest(
              { data,  pm: this.pm,  pmType: this.payment_method_type,  replacePrimary, intent }
            )
          })
        }
        else if(this.pm.type === "direct_debit" && this.isDirectDebitPaymentIntentSupported(data)) {
          return this.submitDirectDebitCheckout(data).then(intent => {
            return PaymentHelper.doApiRequest(
              { data,  pm: this.pm,  pmType: this.payment_method_type,  replacePrimary, intent }
            )
          })
        }
        else if(this.isInAppInstantBankAccountPaymentMethod() && this.isInstantBankPaymentIntentSupported(data)) {
          return this.submitInAppInstantBanking(data).then(intent => {
            return PaymentHelper.doApiRequest(
              { data,  pm: this.pm,  pmType: this.payment_method_type,  replacePrimary, intent }
            )
          })
        }
        else if(this.pm.type=="card" && this.isPaymentIntentFlow(this.pm.id, this.pm.type, data)) {
          const options = {}
          if(!!~["portal_edit_payment_method", "portal_add_payment_method"].indexOf(this.$route.name)) {
            options.amount = _pm && _pm.token_amount;
            if(options.amount == undefined) options.amount = DEFAULT_PI_AMOUNT
          }
          return threeDSHandler(this.$store, data, options).then((intent) =>{
            return PaymentHelper.doApiRequest(
              { data,  pm: this.pm,  pmType: this.payment_method_type,  replacePrimary, intent }
            )
          })
        } else if (this.isCJSButtonPaymentMethod() && this.$store.getters.payment_intent) {
          let intent = this.$store.getters.payment_intent;
          return PaymentHelper.doApiRequest(
            { data,  pm: this.pm,  pmType: this.payment_method_type,  replacePrimary, intent }
          )
        } else {
          this.$store.dispatch("set_payment_intent", undefined);
          this.$store.dispatch("set_payment_data", undefined);
          return PaymentHelper.doApiRequest(
            { data,  pm: this.pm,  pmType: this.payment_method_type,  replacePrimary }
          )
        }
      });
    },

    fetchDetails() {
      return new Promise((resolve, reject) => {
        if(this.payment_method_type == "card") {
          this.$store.dispatch('validate_form', "card").then(success => {
            if(success) {
              var pmData = this.$store.getters.values("card");
              pmData['type'] = this.pm.type;
              if(this.useBillingInfo || this.useShippingInfo) {
                Object.assign(pmData, new CardCopyAddress(this.useBillingInfo ? "billing" : "shipping").copy(this.$store.state));
              }
              if(this.pm.enabled_dlocal && DlocalHelper.canShowDocumentIdField(this.pm, this.$store)) {
                if(this.$store.getters.card_additional_info && this.$store.getters.card_additional_info.transformed_data) {
                  pmData['additional_information'] = JSON.stringify(this.$store.getters.card_additional_info.transformed_data);
                  resolve(pmData);
                } else {
                  let form = this.$store.getters.get_form_temp('dlocal_form');
                  reject({message: this.$store.getters.stranslate('error'), type: "internal", for: "dlocal_form", form:form});
                }
              }
              if(this.pm.gateway_name == "CHARGEBEE_PAYMENTS" && window.cbFinixAuth && window.cbFinixAuth.sessionKey) {
                pmData['additional_information'] = Transformer.getCbPaymentFraudData(window.cbFinixAuth.sessionKey);
              }
              if(this.pm.enabled3ds) {
                resolve(pmData);
              } else if(this.pm.tokenization_config && TokenizationHandler.isTokenizationAllowed(this.pm)) {
                // if tokenization is enabled
                new TokenizationHandler(this.pm.tokenization_config).tokenize(pmData, this.$store.state.auth.customer_handle)
                .then(data => {
                  this.$store.dispatch('set_tmp_storage', {key: data.token, value: pmData});
                  let payload = {tmp_token: data.token, type: this.pm.type};
                  if(data.deviceData){
                    payload['additional_information'] = JSON.stringify(data.deviceData);
                  }
                  resolve(payload);
                }).catch(error => reject(error))
              } else if (this.pm.client_side_encryption_config && (pmData.first_name || pmData.last_name)) {
                // if client side encryption is enabled
                // CARD_HOLDER_NAME is required field for Adyen encrypt function so we skip for empty name
                new ClientSideEncryptionHandler(this.$store, this.pm).encrypt(pmData).then(data => {
                  this.$store.dispatch('set_tmp_storage', {key: data.cipherCard, value: pmData});
                  resolve({tmp_token: data.cipherCard, type: this.pm.type});
                }).catch(error => reject(error));
              } else {
                resolve(pmData);
              }
            }
            else {
              reject({message: this.$store.getters.stranslate('error'), type: "internal"});
            }
          });
        }
        else if(this.isInAppBankAccountPaymentMethod()) {
          this.$store.dispatch('validate_form', "bank_account").then(success => {
            if(success) {
              var pmData = this.$store.getters.values("bank_account");
              // TODO: This is hack to be removed once gw team work on the permanant fix.
              if(this.viaStripeSepa() && pmData['company']) {
                pmData['first_name'] = pmData['company'];
              } else if (this.viaBraintreeAch) {
                pmData.mandate_text = this.pm.configuration.agreement_list?.[0] || '';
              }
              pmData['type'] = this.pm.type;
              resolve(pmData);
            } else {
              reject({message: this.$store.getters.stranslate('error'), type: "internal"});
            }
          });
        } else if(['ideal', 'sofort', 'bancontact', 'upi', 'netbanking_emandates', 'klarna_pay_now'].includes(this.payment_method_type)) {
          this.$store.dispatch('validate_form', this.payment_method_type).then(success => {
            if(success) {
              var pmData = this.$store.getters.values(this.payment_method_type);
              pmData['type'] = this.pm.type;
              resolve(pmData);
            } else {
              reject({message: this.$store.getters.stranslate('error'), type: "internal"});
            }
          });
        } else if(this.isBoletoPaymentMethod()) {
          this.$store.dispatch('validate_form', "bank_account").then(success => {
            if(success) {
              var pmData = this.$store.getters.values("bank_account");
              if(this.useBillingInfo) {
                Object.assign(pmData, new CardCopyAddress("billing").copy(this.$store.state));
              }
              pmData['type'] = this.pm.type;
              resolve(pmData);
            } else {
              reject({message: this.$store.getters.stranslate('error'), type: "internal"});
            }
          });
        } else {
          var pmData = {
            tmp_token: this.token,
            type: this.pm.type
          }
          resolve(pmData)
        }
      });
    },

    viaBraintreeAch() {
      return this.pm && this.pm.gateway_name === UpperCaseGateway.BRAINTREE
            && this.pm.configuration && this.pm.configuration.scheme === "ACH";
    },

    viaStripeSepa() {
      return this.pm && this.pm.gateway_name == "STRIPE"
            && this.pm.configuration && this.pm.configuration.scheme == "SEPA";
    },

    getOrCreatePm() {
      return this.fetchDetails().then(data => {
        data["gateway_account_id"] = this.pm.id;
        data['gateway_name'] = this.pm.gateway_name;
        if(this.$store.state.auth.authenticated){
          if(this.$store.getters.hosted_page_type == "portal") {
            // Set payment intent and handle 3ds
            return this._sendRequest(data);
          }
        }
        return data;
      });
    },

    addExtraMeta() {
      if(this.payment_method_type == "paypal_express_checkout") {
        return {
          meta: {
            payer_email: this.pm_email
          }
        }
      } else if(this.payment_method_type == "venmo") {
        return {
          meta: {
            payer_username: this.pm_username
          }
        }
      }
      else {
        return {};
      }
    },

    submitForCheckout(formData = {}) {
      this.showLoader = true;
      this.submitDLocalFormData();
      return this.getOrCreatePm().then(data => {
        // set payment method as transient
        data.transient = true;
        this.$store.dispatch('add_transient_payment_method', data);
        this.$store.dispatch('add_payment_method', {pm: data})
        this.$store.dispatch('set_payment_method_to_order', Object.assign(data, formData, this.addExtraMeta()));

        this.payment_method_type == "card" && window.cbTimeout(() => this.$store.dispatch('clear_form', "card"), 1000);
        this.payment_method_type != "card" && window.cbTimeout(() => this.$store.dispatch('reset_pm'), 1000);
        this.editMode ? this.$router.push({name: 'review'}) : this.$emit('next');

      }).catch(error => {
        this.showLoader = false;
        this.$store.dispatch('set_current_notification', new CBNotification('error', error));
        this._throwError();
        throw error;
      });
    },

    syncSub(subHandle) {
      if(subHandle) {
        return this.$store.dispatch('load_subscription_details', subHandle);
      }
      return this.$store.dispatch('resync_subscription_details');
    },

    navigatorForPortal(pmId) {
      let canShowPaymentRole = this.hosted_page_type == "portal" && this.mpm_supported
                                && !this.$route.query.sub_handle
                                && !this.$store.getters.is_primary_pm(pmId)
                                && !this.$store.getters.is_backup_pm(pmId);

      let canRedirectActionPage = this.$store.getters.action_pages_redirect_url;
      let sameSource = this.$route.query.source == this.$route.name;
      if(sameSource && this.mpm_supported && canShowPaymentRole) {
          this.$store.dispatch('set_entry_point', "portal_assign_role_payment_method");
          this.$router.customReplace({name: "portal_assign_role_payment_method", params: {pmId: pmId}});
      } else if (sameSource && this.mpm_supported && !canShowPaymentRole) {
          this.$store.dispatch('set_entry_point', "portal_payment_methods");
          this.$router.customPush({name: "portal_payment_methods"});
      } else if (sameSource && !this.mpm_supported && canRedirectActionPage) {
          this.$store.dispatch('action_pages_redirect');
      } else if (sameSource && !this.mpm_supported && !canRedirectActionPage) {
        this.$store.dispatch('set_entry_point', "portal_view_payment_method");
        this.$router.customReplace({name: "portal_view_payment_method", params: {pmId: pmId}});
      } else if (!sameSource && this.is3DSFlowForEdgeBrowser()) {
        this.$router.customPush({name: this.$route.query.source || "home", params: {forEdgeBrowser: true, pmId: pmId}});
      } else if (!sameSource && canShowPaymentRole) {
        this.$router.customReplace({name: "portal_assign_role_payment_method", params: {pmId: pmId}});
      } else {
        this.$router.go(-1);
      }
    },

   submitForPortal(subHandle) {
      let isFailed = false;
      this.showLoader = true;
      let isUpdate = this.$route.name == "portal_edit_payment_method";
      this.submitDLocalFormData();
      this.getOrCreatePm().then(data => {
        this.$store.dispatch('add_payment_method', {pm: data.payment_source, replacePrimary: isUpdate});
        this.$store.dispatch('add_customer_data', data.customer);
        this.syncSub(subHandle).then(() => {
          if(subHandle || this.isOfflinePaymentMethod()) {
            this.$router.go(-1);
          } else {
            this.navigatorForPortal(data.payment_source.id);
          }
          this.payment_method_type == "card" && window.cbTimeout(() => this.$store.dispatch('clear_form', "card"), 1000);
          this.payment_method_type != "card" && window.cbTimeout(() => this.$store.dispatch('reset_pm'), 1000);
          this.showLoader = false;
          window.cbPostMessage({key: isUpdate ? "cb.payment_source.update" : "cb.payment_source.add", status: "success"});
        }).catch(() => {
          this.$store.dispatch('set_current_notification', new CBNotification('error', {message: 'There were errors while updating payment method.'}));
        });
      }).catch((error) => {
        isFailed = true;
        this.showLoader = false;
        this.$store.dispatch('set_current_notification', new CBNotification('error', error));
        this._throwError();
        logger.e(error);
        window.cbPostMessage({key: isUpdate ? "cb.payment_source.update" : "cb.payment_source.add", status: "error"});
      }).finally(() => {
        if(this.is3DSFlowForEdgeBrowser()) {
          this.$store.dispatch("set_back_to_entry_point", isFailed);
        }
      });
    },

    is3DSFlowForEdgeBrowser() {
      return (this.pm.type=="card" && this.isPaymentIntentFlow(this.pm.id, this.pm.type)
            && (/Edge|MSIE|Trident/.test(navigator.userAgent))) || this.pm.type == "bancontact";
    },

    assignPaymentRoleForCust(pmId, role) {
      this.showLoader = true;
      return apiClient.customers.assign_payment_role({id: this.$store.state.auth.customer_handle},
        {
          'payment_source_id': pmId,
          'role': role
        })
        .then((data) => {
          this.showLoader = false;
          return this.$store.dispatch('update_customer_payment_roles', data.customer);
        }).catch((error) => {
          this.showLoader = false;
          this.$store.dispatch('set_current_notification', new CBNotification('error', error));
          logger.e(error);
        });
    },

    addAndSubmitForCollection() {
      this.showLoader = true;
      this.submitDLocalFormData();
      return this._handleCollectPayment(this._addAndSubmitForCollection);
    },

    collectWithExistingPaymentSource(promiseFn) {
      this.showLoader = true;
      return this._handleCollectPayment(this._collectWithExistingPaymentSource);
    },

    _threeDSHandlerFnForCollectNow(saveCard) {
      if(!saveCard || !this.$store.getters.selected_invoices) {
        return threeDSHandler;
      }
      return this.$store.getters.isSingleSubInvoiceSelected ? threeDSHandlerWithMandate : threeDSHandler;
    },

    _addAndSubmitForCollection() {
      // TODO 3ds Set payment intent and handle 3ds
      return this.fetchDetails().then(data => {
        data["gateway_account_id"] = this.pm.id;
        data["gateway_name"] = this.pm.gateway_name;
        // TODO: we can move it to common place. Note: Testing scope will increase so i'm not handled it now.
        if (this.pm.type === 'ideal') {
          return this._submitPaynow({}, true)
          .then((postActionJson) => this.submitIDealCheckoutWithPostAction(postActionJson, data))
          .then(() => data)
        }
        else if (this.pm.type === 'sofort') {
          return this.submitSofortCheckout(data).then(() => data)
        }
        else if (this.pm.type === 'klarna_pay_now') {
          return this.submitKlarnaPayNowCheckout(data).then(() => data)
        }
        else if (this.pm.type === 'bancontact') {
          return this.submitBancontactCheckout(data).then(() => data)
        }
        else if (this.pm.type === 'giropay') {
          return this.submitGiropayCheckout().then(() => data)
        }
        else if (this.pm.type === 'dotpay') {
          return this.submitDotpayCheckout().then(() => data)
        }
        else if (this.pm.type === 'netbanking_emandates') {
          return this.submitNetbankingEmandate(data).then(() => data)
        }
        else if (this.pm.type === 'online_banking_poland') {
          return this.submitOnlineBankingPoland(data).then(() => data)
        }
        else if (this.pm.type === 'upi') {
          return this.submitUpiCheckout(data).then(() => data)
        }
        else if(this.pm.type === "direct_debit" && this.isDirectDebitPaymentIntentSupported(data)) {
          return this.submitDirectDebitCheckout(data).then(() => data)
        }
        else if(this.isInAppInstantBankAccountPaymentMethod() && this.isInstantBankPaymentIntentSupported(data)) {
          return this.submitInAppInstantBanking(data).then(() => data)
        }
        else if(this.pm.type== "card" && this.isPaymentIntentFlow(this.pm.id, this.pm.type, data)) {
          return this._threeDSHandlerFnForCollectNow(this.replace_primary_pm || this.retain_card)(this.$store, data, {amount: this.$store.getters.amountToBePaid})
          .then(() => {
            return data;
          });
        }
        else {
          if(!this.isCJSButtonPaymentMethod() && this.pm.type !== 'apple_pay') {
            this.$store.dispatch("set_payment_intent", undefined);
            this.$store.dispatch("set_payment_data", undefined);
          }
          return Promise.resolve(data);
        }
      }).then((paymentData) => {
        return this._submitPaynow(paymentData, false);
      });
    },

    _submitPaynow(paymentData, postAction) {
      const paynowSubmitter = new PaynowSubmitter(this.$store.state, this.$store.getters);
      return paynowSubmitter.handleCollectNow({
        paymentData,
        replace_primary_payment_source: this.replace_primary_pm,
        retain_payment_source: this.replace_primary_pm ? true : this.retain_card,
        override_billing_profile: this.override_billing_profile,
        postAction,
      });
    },

    _collectWithExistingPaymentSource() {
      // TODO 3ds Set payment intent and handle 3ds
      return Promise.resolve().then(() => {
        // TODO: we can move it to common place. Note: Testing scope will increase so i'm not handled it now.
        // This is unreached code because payment_source has no information abt these types. Even we get type in future this flow
        // is useless because we convert these types into direct_debit for recurrring payment.

        if (this.payment_method.type === 'ideal') {
          return this.submitIDealCheckout().then(intent => {
            return apiClient.customers.collect_payment({id: this.$store.state.auth.customer_handle}, Transformer.collectPaymentWithIntent(this.$store.getters, intent.id))
          })
        }
        else if (this.payment_method.type === 'sofort') {
          return this.submitSofortCheckout().then(intent => {
            return apiClient.customers.collect_payment({id: this.$store.state.auth.customer_handle}, Transformer.collectPaymentWithIntent(this.$store.getters, intent.id))
          })
        }
        else if (this.payment_method.type === 'klarna_pay_now') {
          return this.submitKlarnaPayNowCheckout().then(intent => {
            return apiClient.customers.collect_payment({id: this.$store.state.auth.customer_handle}, Transformer.collectPaymentWithIntent(this.$store.getters, intent.id))
          })
        }
        else if (this.payment_method.type === 'bancontact') {
          return this.submitBancontactCheckout(data).then(intent => {
            return apiClient.customers.collect_payment({id: this.$store.state.auth.customer_handle}, Transformer.collectPaymentWithIntent(this.$store.getters, intent.id))
          })
        }
        else if (this.payment_method.type === 'giropay') {
          return this.submitGiropayCheckout().then(intent => {
            return apiClient.customers.collect_payment({id: this.$store.state.auth.customer_handle}, Transformer.collectPaymentWithIntent(this.$store.getters, intent.id))
          })
        }
        else if (this.payment_method.type === 'netbanking_emandates') {
          return this.submitNetbankingEmandate(data).then(intent => {
            return apiClient.customers.collect_payment({id: this.$store.state.auth.customer_handle}, Transformer.collectPaymentWithIntent(this.$store.getters, intent.id))
          })
        }
        else if (this.payment_method.type === 'online_banking_poland') {
          return this.submitOnlineBankingPoland(data).then(intent => {
            return apiClient.customers.collect_payment({id: this.$store.state.auth.customer_handle}, Transformer.collectPaymentWithIntent(this.$store.getters, intent.id))
          })
        }
        else if (this.payment_method.type === 'upi') {
          return this.submitUpiCheckout(data).then(intent => {
            return apiClient.customers.collect_payment({id: this.$store.state.auth.customer_handle}, Transformer.collectPaymentWithIntent(this.$store.getters, intent.id))
          })
        }
        else if (this.payment_method.type === 'direct_debit' && this.isDirectDebitPaymentIntentSupported(this.payment_method)) {
          return this.submitDirectDebitCheckout(this.payment_method).then(intent => {
            return apiClient.customers.collect_payment({id: this.$store.state.auth.customer_handle}, Transformer.collectPaymentWithIntent(this.$store.getters, intent.id))
          })
        }
        else if(this.isInAppInstantBankAccountPaymentMethod(this.payment_method.type) && this.isInstantBankPaymentIntentSupported(this.payment_method)) {
          return this.submitInAppInstantBanking(this.payment_method).then(intent => {
            return apiClient.customers.collect_payment({id: this.$store.state.auth.customer_handle}, Transformer.collectPaymentWithIntent(this.$store.getters, intent.id))
          })
        }
        else if(this.payment_method.type=="card" && this.isPaymentIntentFlow(this.payment_method.gateway_account_id, this.payment_method.type, this.payment_method)) {
          return this._threeDSHandlerFnForCollectNow(true)(this.$store, this.payment_method, {amount: this.$store.getters.amountToBePaid})
          .then((intent) => {
            return apiClient.customers.collect_payment({id: this.$store.state.auth.customer_handle}, Transformer.collectPaymentWithIntent(this.$store.getters, intent.id))
          });
        }
        else {
          return this.$store.dispatch("set_payment_intent", undefined).then(() => apiClient.customers.collect_payment({id: this.$store.state.auth.customer_handle}, Transformer.collectPaymentExistingPaymentId(this.$store.getters, this.payment_source_id)));
        }
      });
    },

    _handleCollectPayment(promiseFn) {
      return promiseFn().then(data => {
        if(!(data.transaction && (data.transaction.status == "success" || data.transaction.status == "in_progress"))) {
          this.showLoader = false;
          this.$store.dispatch('set_current_notification', new CBNotification('error', {message: data.transaction.error_text || "There were errors while collecting funds. Please try again later", isDismissible: true}));
          if(!data.transaction.error_text) {
            logger.e(new Error("There were errors while collecting funds. Please try again later"));
          }
          return;
        }

        // KVL log transaction data
        this.$store.dispatch('log_transaction', data.transaction)
          .then(() => this.$store.dispatch('transmit_log_data'));

        Promise.all([
          this.$store.dispatch('add_customer_data', data.customer),
          this.$store.dispatch('set_collect_now_transactions', data.transactions),
        ])
        .then(() => {
          if(this.$store.getters.can_allow("pay_now.add_multiple_pm") &&
              this.$store.getters.can_allow("pay_now.save_pm_backup") &&
              this.retain_card && this.$store.getters.paynow_pm_role != undefined) {
                return this.assignPaymentRoleForCust(data.transaction.payment_source_id,
                                                this.$store.getters.paynow_pm_role);
          }
          return Promise.resolve();
        })
      })
      .then(() => {
        if (this.$store.getters.collect_now_txn_max_limit_reached) {
          return Promise.resolve();
        }
        return this.$store.dispatch('load_payment_method_list');
      })
      .then(() => {
        this.showLoader = false;
        const hasUnpaidInvoices = this.$store.getters.valid_invoices.length - this.$store.getters.selected_invoices.length > 0;
        const maxTxnLimitReached = this.$store.getters.collect_now_txn_max_limit_reached;
        const hasRedirectUrl = !!this.$store.getters.action_pages_redirect_url;
        if(hasRedirectUrl && (!hasUnpaidInvoices || maxTxnLimitReached)) {
          this.$store.dispatch('action_pages_redirect');
        } else {
          this.$router.push({
            name: 'thankyou'
          });
        }
      }).catch((error) => {
        this.showLoader = false;
        this.$store.dispatch('set_current_notification', new CBNotification('error', error));
        logger.e(error);
      });
    },

    addPaymentMethod() {
      this.submitDLocalFormData();
      return this.getOrCreatePm().then(data => {
        // set payment method as transient
        data.transient = true;
        this.$store.dispatch('add_transient_payment_method', data);
        this.$store.dispatch('add_payment_method', {pm: data})
        this.$store.dispatch('set_payment_method_to_order', Object.assign(data, this.addExtraMeta()));
      }).catch(error => {
        this.showLoader = false;
        this.$store.dispatch('set_current_notification', new CBNotification('error', error));
        this._throwError();
        throw error;
      });
    },

    subscribe() {
      this.showLoader = true;
      this.fetchDetails()
      .then(data => {
        data["gateway_account_id"] = this.pm.id;
        if(this.pm.type=="card" && this.isPaymentIntentFlow(this.pm.id, this.pm.type, data)) {
          return threeDSHandler(this.$store, data)
          .then(() => {
            return data;
          });
        }
        else if(this.pm.type === 'ideal') {
          return this.submitIDealCheckout().then(() => data)
        }
        else if(this.pm.type === 'sofort') {
          return this.submitSofortCheckout().then(() => data)
        }
        else if(this.pm.type === 'klarna_pay_now') {
          return this.submitKlarnaPayNowCheckout().then(() => data)
        }
        // TODO: we can move it to common place. Note: Testing scope will increase so i'm not handled it now.
        else if(!!~['bancontact'].indexOf(this.pm.type)) {
          return this.submitBancontactCheckout().then(() => data)
        }
        else if(this.pm.type === 'giropay') {
          return this.submitGiropayCheckout().then(() => data)
        }
        else if(this.pm.type === 'netbanking_emandates') {
          return this.submitNetbankingEmandate().then(() => data)
        } else if(this.pm.type === 'online_banking_poland') {
          return this.submitOnlineBankingPoland().then(() => data)
        }
        else if(this.pm.type === 'upi') {
          return this.submitUpiCheckout().then(() => data)
        }
        else if(this.pm.type === "direct_debit" && this.isDirectDebitPaymentIntentSupported(data)) {
          return this.submitDirectDebitCheckout(data).then(() => data)
        }
        else if(this.isInAppInstantBankAccountPaymentMethod() && this.isInstantBankPaymentIntentSupported(data)) {
          return this.submitInAppInstantBanking(data).then(() => data)
        } else {
          if(!this.isCJSButtonPaymentMethod()) {
            this.$store.dispatch("set_payment_intent", undefined);
            this.$store.dispatch("set_payment_data", undefined);
          }
          return Promise.resolve(data);
        }
      })
      .then(data => {
        if(this.$store.getters.payment_intent) {
          var transformedData = Transformer.createPaymentSourceUsingPaymentIntent(this.$store.getters.payment_intent, this.$store.state, this.$store.getters)
        }
        else if(this.payment_method_type == 'card' && !data.tmp_token){
          var transformedData = Transformer.createCardPaymentSource(this.$store.state, this.$store.getters, data)
        } else if(this.isInAppBankAccountPaymentMethod() && !data.tmp_token) {
          var transformedData = Transformer.createBankAccountPaymentSource(this.$store.state, this.$store.getters, data)
        } else {
          var transformedData = Transformer.createPaymentSourceUsingTmpToken(this.$store.state, this.$store.getters, data)
        }
        if(this.$store.state.auth.authenticated) {
          var promise;
          this.$store.dispatch('add_transient_payment_method', data);
          this.$store.dispatch('set_payment_method_to_order', data);
          if(this.is_checkout_one_time) {
            return this._submitOneTimeCheckout();
          }
          if(this.is_checkout_existing) {
            promise = apiClient.subscriptions.update_bulk({
              id: this.$store.getters.subscription_handle,
              hp_token: this.$store.state.auth.hpToken
            },
            Object.assign(transformedData, Transformer.updateSubscription(this.$store.state)))
          }
          else {
            promise = apiClient.customers.create_subscription_bulk({
                id: this.$store.state.auth.customer_handle,
                hp_token: this.$store.state.auth.hpToken
              },
              Object.assign(transformedData, Transformer.createSubscriptionForCustomer(this.$store.state)))
          }
          promise.then((data) => {
            this.showLoader = false;
            this.openThankYouPage(data);
          })
          .catch((error) => {
            this.showLoader = false;
            this.$store.dispatch('set_current_notification', new CBNotification('error', error));
            if(this.isInAppBankAccountPaymentMethod()){
              this._throwError();
            }
            logger.e(error);
          });
        }
        else {
          this.$store.dispatch('add_transient_payment_method', data);
          this.$store.dispatch('set_payment_method_to_order', data);
          if(this.is_checkout_one_time) {
            return this._submitOneTimeCheckout();
          }
          apiClient.subscriptions.create({
              hp_token: this.$store.state.auth.hpToken
            },
            Transformer.createSubscription(this.$store.state))
          .then((data) => {
            this.showLoader = false;
            this.openThankYouPage(data);
          })
          .catch((error) => {
            this.showLoader = false;
            this.$store.dispatch('set_current_notification', new CBNotification('error', error));
            EventBus.$emit('hp_log', {action:'checkout_failed', error:error});
            if(this.isInAppBankAccountPaymentMethod()){
              this._throwError();
            }
            logger.e(error);
          });
        }
      }).catch(error => {
        this.showLoader = false;
        this.$store.dispatch('set_current_notification', new CBNotification('error', error));
        logger.e(error);
      });
    },
    _submitOneTimeCheckout() {
      this.showLoader = true;
      this.submitCheckoutOneTime().then((data) => {
        this.showLoader = false;
        this.$store.dispatch('set_recaptcha_checkout',false)
        this.openThankYouPage(data);
      })
      .catch((error) => {
        this.showLoader = false;
        if (error.type) {
          this.highlightSection = error.type;
        }
        this.$store.dispatch('set_current_notification', new CBNotification('error', error));
        EventBus.$emit('hp_log', {action:'checkout_failed', error});
        logger.e(error);
      })
    },

    openThankYouPage(data) {
      // for trial, zero dollar & full discount plan we will not create a voucher so we will redirect user to thank you page
      if(this.is_boleto_payment && (data.invoice && data.invoice.id && data.invoice.amount_due)) {

        EventBus.$emit('checkout_submitted', data ? {
          ...data,
          skip_redirection: true
        }: { skip_redirection: true });

        let redirectUrl = data.extra_info && data.extra_info.redirect_url;
        this.$store.dispatch("set_hp_redirect_url", redirectUrl)
        this.$store.dispatch("load_voucher_data", data.invoice.id).then(() => {
          this.$router.push({
            name: 'voucher'
          })
        }).catch((err) => {
          logger.e(err);
          this.$router.push({
            name: 'thankyou'
          })
        });
      } else {
        EventBus.$emit('checkout_submitted', data);
        this.$router.push({
          name: 'thankyou'
        })
      }
    },

    submitIDealCheckoutWithPostAction(postActionJson, data) {
      return this.submitIDealCheckout({postActionJson, data});
    },

    submitIDealCheckout(input) {
      const paymentData = this.$store.getters.selected_payment_method || input?.data;
      const cbInstance = Chargebee.getInstance()
      return cbInstance.handlePayment(IDEAL, {
        paymentIntent: () => {
          return createPaymentIntent(this.$store, {}, {
            paymentMethodType: IDEAL,
            postAction: input?.postActionJson || null
          })
        },
        paymentInfo: this.getIDealPaymentInfo(paymentData)
      }).then(intent => {
        this.$store.dispatch("set_payment_intent", intent);
        return intent;
      })
    },

    getFullName() {
      const firstName = this.$store.getters.customer_data ?.first_name;
      const lastName = this.$store.getters.customer_data ?.last_name;
      return lastName ? firstName.concat(' ', lastName) : firstName;
    },

    isRetainPaymentMethod() {
      return this.replace_primary_pm || this.retain_card;
    },

    getIDealPaymentInfo(paymentInfo) {
      const paymentData = this.$store.getters.selected_payment_method || paymentInfo;
      const customerEmail = this.$store.getters.customer_email;
      if (paymentData && paymentData.gateway_name) {
        const {gateway_name, owner_name, owner_email} = paymentData
        switch (gateway_name) {
          case 'STRIPE':
            return {userName: owner_name, userEmail: owner_email, retainPaymentMethod: this.isRetainPaymentMethod()}
          case 'MOLLIE':
            return {userName: this.getFullName(), userEmail: customerEmail}
          case 'CHECKOUT_COM':
            return {userEmail: owner_email}
        }
      }
    },

    getSofortPaymentInfo(paymentInfo) {
      const paymentData =  this.$store.getters.selected_payment_method || paymentInfo
      const customerEmail = this.$store.getters.customer_email;
      if (paymentData && paymentData.gateway_name) {
        const {gateway_name, type, owner_name, owner_email, owner_country} = paymentData
        switch (gateway_name) {
          case 'STRIPE':
            return {userName: owner_name, userEmail: owner_email, country: owner_country}
          case 'MOLLIE':
            return {userName: this.getFullName(), userEmail: customerEmail}
        }
      }
    },

    getDirectDebitPaymentInfo(paymentInfo) {
      const pm = this.$store.getters.pm_list.filter((gw) => gw.type == DIRECT_DEBIT)[0];
      const paymentData =  this.$store.getters.selected_payment_method || paymentInfo;
      return CbjsTransformer.get(pm, paymentData, this.$store);
    },

    getPaymentInfo(paymentInfo, pmConfig) {
      const pm = pmConfig || this.$store.getters.pm_list.filter((gw) => gw.type == paymentInfo.type)[0];
      const paymentData =  this.$store.getters.selected_payment_method || paymentInfo;
      return CbjsTransformer.get(pm, paymentData, this.$store);
    },

    getBancontactPaymentInfo(paymentData) {
      const customerEmail = this.$store.getters.customer_email;
      if (paymentData && paymentData.gateway_name) {
        const {gateway_name, first_name = '', last_name = '', owner_name, owner_email, owner_country} = paymentData
        const userName = owner_name || `${first_name} ${last_name}`.trim()
        switch (gateway_name) {
          case 'STRIPE':
            return {userName, userEmail: owner_email, retainPaymentMethod: this.isRetainPaymentMethod()}
          case 'CHECKOUT_COM':
            return {userName, userEmail: owner_email, country: owner_country}
          case 'MOLLIE':
            return {userName, userEmail: customerEmail}
        }
      }
    },

    submitSofortCheckout(paymentInfo) {
      const cbInstance = Chargebee.getInstance()
      return cbInstance.handlePayment(SOFORT, {
        paymentIntent: () => {
          return createPaymentIntent(this.$store, {}, {
            paymentMethodType: SOFORT
          })
        },
        paymentInfo: this.getSofortPaymentInfo(paymentInfo)
      }).then(intent => {
        this.$store.dispatch("set_payment_intent", intent);
        return intent;
      })
    },
    submitKlarnaPayNowCheckout(paymentInfo) {
      const paymentData =  this.$store.getters.selected_payment_method || paymentInfo;
      const pm = this.$store.getters.pm_list.filter((gw) => gw.type == KLARNA_PAY_NOW)[0];
      if(paymentData.reference_id){
        this.$store.dispatch("set_payment_intent", undefined);
      } else {
        const cbInstance = Chargebee.getInstance()
        return cbInstance.handlePayment(KLARNA_PAY_NOW, {
          paymentIntent: () => {
            return createPaymentIntent(this.$store, {}, {
              paymentMethodType: KLARNA_PAY_NOW
            })
          },
          paymentInfo: CbjsTransformer.get(pm, paymentData, this.$store)
        }).then(intent => {
          this.$store.dispatch("set_payment_intent", intent);
          return intent;
        })
      }
    },

    submitDirectDebitCheckout(paymentInfo) {
      return Promise.resolve().then(() => {
        if(PaymentHelper.isPreAuthDirectDebit()) {
          let intent = this.$store.getters.payment_intent;
          if(intent.status == 'authorized'
              && paymentInfo.gateway_account_id == intent.gateway_account_id) {
            return intent;
          }
        }
        const cbInstance = Chargebee.getInstance()
        let directDebitHandler = null;
        return cbInstance.loadDirectDebit()
        .then(h => {
          directDebitHandler = h;
          return createPaymentIntent(this.$store, paymentInfo, {
            paymentMethodType: DIRECT_DEBIT
          }).then(intent => {
            const currentIntent = directDebitHandler.getPaymentIntent()
            if (!currentIntent || currentIntent.id !== intent.id) {
              directDebitHandler.setPaymentIntent(intent);
            }
          })
        })
        .then(() => directDebitHandler.handlePayment(this.getDirectDebitPaymentInfo(paymentInfo)))
        .then(intent => {
          this.$store.dispatch("set_payment_intent", intent);
          return intent;
        })
      });
    },

    submitInAppInstantBanking(paymentInfo) {
      const pm = this.$store.getters.pm_list.filter((gw) => gw.type == paymentInfo.type)[0];
      if(pm.type == 'pay_to' && pm.configuration.local_details_enabled) {
        return this.submitInAppInstantBankingWithLoader(pm, paymentInfo)
      }
      const cbInstance = Chargebee.getInstance()
      return cbInstance.handlePayment(paymentInfo.type, {
        paymentIntent: () => {
          return createPaymentIntent(this.$store, {
            type: pm.type,
            gateway_account_id: pm.id
          })
        },
        paymentInfo: this.getPaymentInfo(paymentInfo)
      }).then((intent) => {
        this.$store.dispatch("set_payment_intent", intent);
        return intent;
      })
    },

    submitInAppInstantBankingWithLoader(pm, paymentInfo) {
      const cbInstance = Chargebee.getInstance();
      return new Promise((resolve, reject) => {
        createPaymentIntent(this.$store, {
          type: pm.type,
          gateway_account_id: pm.id
        }).then(intent => {
          this.$router.push({
            name: 'awaiting_for_confirmation'
          })
          return cbInstance.handlePayment(paymentInfo.type, {
            paymentIntent: () => {
              return Promise.resolve(intent);
            },
            paymentInfo: this.getPaymentInfo(paymentInfo)
          })
        }).then(intent => {
          this.$store.dispatch("set_payment_intent", intent);
          this.handleUpiTimerPaymentLoaderRoute(false)
          resolve(intent);
        }).catch(error => {
          this.handleUpiTimerPaymentLoaderRoute(true)
          reject(error);
        })
      });
    },

    submitBancontactCheckout(paymentInfo) {
      const paymentData = this.$store.getters.selected_payment_method || paymentInfo
      const cbInstance = Chargebee.getInstance()
      return cbInstance.handlePayment(BANCONTACT, {
        paymentInfo: {
          ...Transformer.getPaymentInfo(paymentData), // returns card payment info
          ...this.getBancontactPaymentInfo(paymentData)
        }
      }).then((intent) => {
        this.$store.dispatch("set_payment_intent", intent);
        return intent;
      })
    },

    submitGooglePayCheckout() {
      return Promise.resolve(this.$store.getters.payment_intent);
    },

    submitPreAuthorizedCheckout() {
      let authorizedPI;
      if (this.$store.getters.payment_intent && this.$store.getters.payment_intent.status == "authorized") {
        authorizedPI = this.$store.getters.payment_intent;
      } else {
        this.$store.dispatch("set_payment_intent", undefined);
      }
      return Promise.resolve(authorizedPI);
    },

    getRazorpayAdditionalData(pmType, shippingAddress) {
      return PaymentHelper.getRazorpayAdditionalData(pmType, {
        shippingAddress: shippingAddress ? {...shippingAddress, firstName: shippingAddress.first_name, lastName: shippingAddress.last_name, addressLine1: shippingAddress.line1,
                                            addressLine2: shippingAddress.line2, stateCode: shippingAddress.state_code, countryCode: shippingAddress.country}: {},
        replace_primary_pm: this.replace_primary_pm,
        retain_card: this.retain_card
      })
    },

    getUpiPaymentInfo(paymentInfo) {
      const paymentData =  this.$store.getters.selected_payment_method || paymentInfo;
      if (paymentData && paymentData.gateway_name) {
        const {gateway_name, first_name, last_name, email, phone, vpa} = paymentData
        switch (gateway_name) {
          case 'RAZORPAY':
            return {
              vpa: vpa,
              customer: {
                first_name: first_name,
                last_name: last_name,
                email: email,
                phone: phone
              },
              additionalData : this.getRazorpayAdditionalData('upi', this.$store.getters.selected_shipping_address)
            }
        }
      }
    },

    submitUpiCheckout(paymentInfo) {
      const cbInstance = Chargebee.getInstance();
      return new Promise((resolve, reject) => {
        Promise.all([createPaymentIntent(this.$store, {}, {
            paymentMethodType: UPI
          }), cbInstance.loadUpi()
        ]).then(([intent, handler]) => {
          handler.setPaymentIntent(intent);
          this.$router.push({
            name: 'upi_timer'
          })
          return handler.handlePayment(this.getUpiPaymentInfo(paymentInfo))
        }).then(intent => {
          this.$store.dispatch("set_payment_intent", intent);
          this.handleUpiTimerPaymentLoaderRoute(false)
          resolve(intent);
        }).catch(error => {
          this.handleUpiTimerPaymentLoaderRoute(true)
          reject(error);
        })
      })
    },

    handleUpiTimerPaymentLoaderRoute(onError) {
      if(["upi_timer", "awaiting_for_confirmation"].includes(this.$route.name)) {
        if(onError) {
          this.$router.go(-1)
        } else if (!(this.$store.getters.hosted_page_type === 'paynow' || this.one_screen_checkout)) {
          this.$router.go(-1)
        }
      }
    },

    submitGiropayCheckout() {
      const cbInstance = Chargebee.getInstance()
      return cbInstance.handlePayment(GIROPAY, {
        paymentIntent: () => {
          return createPaymentIntent(this.$store, {}, {
            paymentMethodType: GIROPAY
          })
        }
      }).then(intent => {
        this.$store.dispatch("set_payment_intent", intent);
        return intent;
      })
    },

    submitDotpayCheckout() {
      //  dotpay is supported only in paynow
      const cbInstance = Chargebee.getInstance()
      return cbInstance.handlePayment(DOTPAY, {
        paymentIntent: () => {
          return createPaymentIntent(this.$store, {}, {
            paymentMethodType: DOTPAY
          })
        }
      }).then(intent => {
        this.$store.dispatch("set_payment_intent", intent);
        return intent;
      })
    },

    getNetbankingEmandatePaymentInfo(paymentData) {
      if (paymentData && paymentData.gateway_name) {
        const {gateway_name} = paymentData;
        switch (gateway_name) {
          case 'RAZORPAY':
            const custmerData = this.$store.getters.customer_data;
            const formData = this.$store.getters.values("netbanking_emandates");
            return {
              customer: {
                "firstName" :  formData.beneficiary_name || custmerData.first_name,
                "lastName" : custmerData.last_name || '',
                "email": formData.email || custmerData.email,
                "phone" : formData.phone || custmerData.phone
              },
              bankAccount: {
                "bank" : formData.bank,
                "beneficiaryName": formData.beneficiary_name,
                "accountNumber": formData.account_number,
                "accountType": formData.account_type,
                "ifscCode": formData.ifsc_code
              },
              additionalData : this.getRazorpayAdditionalData('netbanking_emandates', this.$store.getters.selected_shipping_address)
            }
        }
      }
    },

    submitNetbankingEmandate(paymentInfo) {
      const paymentData = this.$store.getters.selected_payment_method || paymentInfo;
      const cbInstance = Chargebee.getInstance();
      return cbInstance.handlePayment(NETBANKING_EMANDATES, {
        paymentInfo: this.getNetbankingEmandatePaymentInfo(paymentData)
      }).then(intent => {
        this.$store.dispatch("set_payment_intent", intent);
        return intent;
      })
    },

    getOnlineBankingPolandPaymentInfo(paymentData) {
      if (paymentData && paymentData.gateway_name) {
        const {gateway_name} = paymentData;
        switch (gateway_name) {
          case 'ADYEN':
            const custmerData = this.$store.getters.customer_data;
            const formData = this.$store.getters.values("online_banking_poland");
            return {
              customer: {
                "firstName" :  formData.beneficiary_name || custmerData.first_name,
                "lastName" : custmerData.last_name || '',
                "email": formData.email || custmerData.email,
                "phone" : formData.phone || custmerData.phone
              },
              email: formData.email || custmerData.email,
              issuerBank: formData.bank,
            }
        }
      }
    },

    submitOnlineBankingPoland(paymentInfo) {
      const paymentData = this.$store.getters.selected_payment_method || paymentInfo;
      const cbInstance = Chargebee.getInstance();
      return cbInstance.handlePayment(ONLINE_BANKING_POLAND, this.getOnlineBankingPolandPaymentInfo(paymentData))
        .then(intent => {
        this.$store.dispatch("set_payment_intent", intent);
        return intent;
      })
    },

    validateForm() {
      this.$store.dispatch('validate_form', this.fname || "card").then((success) => {
        if(success) this.$store.dispatch("set_mandate_step", SECOND_STEP);
      });
    },

    validateAndProceed() {
      const _this = this
      const validator = this.$refs?.child?.validate ?
        this.$refs.child.validate() : Promise.resolve()
      validator
        .then(data => {
        _this.proceed(data)
      })
      .catch(error => {
        _this.showLoader = false;
        _this.$store.dispatch('set_current_notification', new CBNotification('error', error));
        _this._throwError();
        logger.e(error);
      });
    },
	},
	data() {
		return{
      // payment_method: "card"
      fname: '',
      payment_step: FIRST_STEP
		}
	},
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if(from.name == "upi_timer"
        && vm.$store.getters.payment_intent
        && vm.$store.getters.payment_intent.payment_method_type == 'upi'
        && vm.$store.getters.payment_intent.status == 'authorized') {
        vm.showLoader = true;
      } else if((from.name ==  vm.$store.getters.hosted_page_type + "_gocardless_guarantee") && vm.$store.getters.get_form_temp('bacs_form')) {
        vm.$store.commit('SHOW_BANK_REVIEW', true);
      }
    })
  },
  components: {
    "cb-button": ButtonField,
    "checkout-subscribe": CheckoutSubscribeComponent
  },
  computed: {
    ...mapGetters([
      "mpm_supported",
      "pm_list",
      "pm_token",
      "pm_email",
      "pm_username",
      "pm_authorized",
      "pm_consent",
      "hosted_page_type",
      "recaptcha_key",
      "init_info_locale",
      "one_screen_checkout",
      "mandate_step",
      "show_mandate_screen",
      "is_boleto_payment",
      "is_klarna_pay_now_payment",
      "is_online_banking_poland_payment"
    ]),
    pm() {
      return this.$store.getters.pm_by_type(this.payment_method_type);
    },
    token() {
      // For now lets use it for paypal express checkout
      return this.pm_token;
    },
    field_config() {
      return FieldConfig.configFields(
        FieldConfig.getGatewayFieldConfig(this.pm),
        this.$store.getters.get_text
      );
    },
    show_mandate_review() {
      if(this.hosted_page_type == "paynow") {
        return this.$store.getters.isSingleSubInvoiceSelected
      } else {
        return this.show_mandate_screen;
      }
    },
    allow_save_new_mandate_payment_method() {
      const mandateEnabled = this.isMandateEnabledPaymentMethod();
      if(mandateEnabled && this.hosted_page_type == 'paynow') {
        return this.$store.getters.isSingleSubInvoiceSelected
      } else if(this.is_checkout_one_time) {
        return ![UpperCaseGateway.RAZORPAY].includes(this.pm.gateway_name);
      } else {
        return true;
      }
    },
    show_card_review_btn() {
      // currently we don't support mandate in portal for razorpay
      if(this.hosted_page_type == "portal" && !this.show_mandate_screen) {
        return false;
      }
      return this.isMandateEnabledPaymentMethod() && this.payment_step == FIRST_STEP;
    },
  },
  watch: {
    payment_method_type(newValue, oldValue){
      this.fname = newValue
      this.swapPaymentMethod = false;
      this.$store.dispatch('set_loader', true);
      this.$nextTick(function() {
        this.swapPaymentMethod = true;
        window.cbTimeout(() => {
          this.$store.dispatch('set_loader', false);
        }, 400);//400 animation duration
      });
    },
    mandate_step: function (val) {
      this.payment_step = this.mandate_step;
    },
  },
}
